import { render, staticRenderFns } from "./Desk.TableCell.vue?vue&type=template&id=67227660&scoped=true"
import script from "./Desk.TableCell.vue?vue&type=script&lang=js"
export * from "./Desk.TableCell.vue?vue&type=script&lang=js"
import style0 from "./Desk.TableCell.vue?vue&type=style&index=0&id=67227660&prod&lang=css"
import style1 from "./Desk.TableCell.vue?vue&type=style&index=1&id=67227660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67227660",
  null
  
)

export default component.exports